import { routes } from "../helpers/constants";

export const dmReportList = [
  {
    route: routes.dmRestaurantReport,
    isActive: true,
    value: "USER",
    label: "RESTAURANT",
    title: "RESTAURANT",
  },
  {
    route: routes.dmFTSReport,
    isActive: true,
    value: "FTS",
    label: "FTS",
    title: "FTS",
  },
  {
    route: routes.dmAuditorReport,
    isActive: true,
    value: "AUDITOR",
    label: "AUDITOR",
    title: "AUDITOR",
  },
  {
    route: routes.dmLabReport,
    isActive: true,
    value: "LAB",
    label: "LAB",
    title: "LAB",
  },
];

export const adminReportList = [
  {
    route: routes.adminFTSReport,
    isActive: true,
    value: "FTS",
    label: "FTS",
    title: "FTS",
  },
  {
    route: routes.adminRestaurantReport,
    isActive: true,
    value: "USER",
    label: "RESTAURANT",
    title: "RESTAURANT",
  },
 
  {
    route: routes.adminAuditorReport,
    isActive: true,
    value: "AUDITOR",
    label: "AUDITOR",
    title: "AUDITOR",
  },
  {
    route: routes.adminLabReport,
    isActive: true,
    value: "LAB",
    label: "LAB",
    title: "LAB",
  },
];
